import Icon from '@mui/material/Icon';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import BasicMenu from '../../../../../components/BasicMenu';
import { useAppDispatch, useAppSelector } from '../../../../../hooks';
import {
  refreshServiceLogSummary,
  selectLastUpdatedServiceLog,
} from '../../../../../slices/utils/utilsSlice';
import { getTimeDiff } from '../../../../../components/Notifications/utils';
import useConfirm from '../../../../../hooks/useConfirm';
import { AxiosResponse } from 'axios';
import fetchClient from '../../../../../services/axios';
import { alertError, alertSuccess } from '../../../../../slices/global/alertSlice';

export default function ServiceLogSettings() {
  const { promptConfirm } = useConfirm();
  const lastUpdated = useAppSelector(selectLastUpdatedServiceLog);
  const dispatch = useAppDispatch();

  const dismissAllLogs = async () => {
    const isConfirmed = await promptConfirm(
      'Dismiss all logs?',
      'Warning! You are about to dismiss all logs, do you wish to continue?',
      'Yes, dismiss all',
      'Cancel',
    );
    if (!isConfirmed) return;

    await fetchClient
      .post('/ServiceLog/DismissAllLogs')
      .then((response: AxiosResponse) => {
        if (!response.data.isSuccessStatusCode) {
          dispatch(alertError(`Failed to dismiss. Reason: ${response.data.reasonPhrase}`));
        } else {
          dispatch(alertSuccess('Logs dismissed'));
          dispatch(refreshServiceLogSummary(true));
        }
      })
      .catch(function (err) {
        if (err.message !== 'canceled') dispatch(alertError(`Failed to dismiss. Reason: ${err}`));
      });
  };

  return (
    <BasicMenu direction="vert">
      <ListItemButton onClick={() => dispatch(refreshServiceLogSummary(true))}>
        <ListItemIcon>
          <Icon>refresh</Icon>
        </ListItemIcon>
        <ListItemText
          primary="Refresh data"
          secondary={lastUpdated && `Last updated: ${getTimeDiff(lastUpdated.toString())}`}
        />
      </ListItemButton>
      <ListItemButton onClick={async () => await dismissAllLogs()}>
        <ListItemIcon>
          <Icon>cancel</Icon>
        </ListItemIcon>
        <ListItemText primary="Dismiss ALL logs" />
      </ListItemButton>
    </BasicMenu>
  );
}
